import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal, ModalContainer, Overlay } from '../ModalContainer';
import Button from '../shared/Button';
import DeleteButton from '../shared/DeleteButton';
import { cancelShipOrder } from '../../utils/Apis/shipping';

const DEFAULT_REASON = 'Customer requested cancellation';

const CancelShipModal = ({ isOpen, onClose, orderId, onSuccess }) => {
  const [cancelReason, setCancelReason] = useState(DEFAULT_REASON);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCancelReason(DEFAULT_REASON);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const normalizedReason = cancelReason.trim();
    if (!normalizedReason) {
      toast.error('Please provide a cancellation reason');
      return;
    }

    setLoading(true);
    try {
      await cancelShipOrder({
        orderId,
        cancel_reason: normalizedReason,
      });
      toast.success('Shipment cancelled successfully');
      onSuccess?.();
      onClose?.();
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || 'Failed to cancel shipment';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalContainer>
      <Overlay onClick={loading ? undefined : onClose} />
      <Modal className="w-[92vw] max-w-xl rounded-lg bg-background shadow-xl">
        <form className="flex flex-col gap-4 p-6" onSubmit={handleSubmit}>
          <div>
            <h2 className="text-xl font-semibold">Cancel 4PX Shipment</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              4PX requires a cancellation reason before the direct shipment can be cancelled.
            </p>
          </div>

          <label className="flex flex-col gap-2 text-sm font-medium">
            Cancellation Reason
            <textarea
              className="min-h-28 rounded-md border px-3 py-2 outline-none focus:ring-2"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              maxLength={128}
              placeholder="Enter the 4PX cancellation reason"
              disabled={loading}
              required
            />
          </label>

          <p className="text-xs text-muted-foreground">
            Keep it within 128 characters to match the 4PX API requirement.
          </p>

          <div className="flex justify-end gap-3">
            <Button
              type="button"
              className="bg-secondary/70 text-foreground hover:bg-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Keep Shipment
            </Button>
            <DeleteButton type="submit" disabled={loading}>
              {loading ? 'Cancelling...' : 'Cancel Shipment'}
            </DeleteButton>
          </div>
        </form>
      </Modal>
    </ModalContainer>
  );
};

export default CancelShipModal;
